export enum Role {
  Student = 'student',
  Instructor = 'instructor',
  Admin = 'admin',
  ContentCreator = 'content-creator',
  VieScolaire = 'vie-scolaire',
  Pedagogie = 'pedagogie'
}
